import React, { useEffect } from "react";
import {
  FaBalanceScale,
  FaHandshake,
  FaChartLine,
  FaUserShield,
  FaSearchDollar,
  FaPercent,
} from "react-icons/fa";
import "../Why/Why.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { GiCalculator } from "react-icons/gi";

const Why = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    // Animation for the main heading
    gsap.to(".main-heading-pcw", {
      scale: 2,
      duration: 2,
      ease: "power2.out",
      delay: 1.5,
      scrollTrigger: {
        trigger: ".service-section",
        start: "top center",
        end: "bottom center",
        scrub: 1,
        toggleActions: "restart reverse restart reverse",
      },
    });

    // Animation for grid items
    gsap.fromTo(
      ".service-item",
      {
        opacity: 0,
        y: 50, // Start slightly below
        scale: 0.8, // Start slightly smaller
      },
      {
        opacity: 1,
        y: 0, // Move to original position
        scale: 1, // Scale up to original size
        duration: 0.8,
        stagger: 0.2, // Add delay between each item
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".service-grid",
          start: "top 80%", // Trigger when the grid enters 80% of the viewport
          end: "bottom 20%", // End when leaving the viewport
          toggleActions: "play reverse play reverse", // Reverse animation when scrolling back
        },
      },
    );
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  const reasons = [
    {
      heading: "Expert Financial Team",
      text: "Our seasoned professionals specialize in various domains to provide comprehensive solutions.",
      icon: <FaBalanceScale />,
    },
    {
      heading: "Proven Success Record",
      text: "We have a history of successfully managing complex financial challenges.",
      icon: <FaChartLine />,
    },
    {
      heading: "Client-Focused Approach",
      text: "Your goals and interests are at the core of every solution we offer.",
      icon: <FaHandshake />,
    },
    {
      heading: "Transparent Processes",
      text: "We ensure complete transparency and keep you informed every step of the way.",
      icon: <FaUserShield />,
    },
    {
      heading: "Customized Strategies",
      text: "Tailored financial solutions designed to fit your specific requirements.",
      icon: <FaSearchDollar />,
    },
    {
      heading: "Exclusive Discounts",
      text: "Avail exclusive discounts on your first consultation or financial service.",
      icon: <FaPercent />,
    },
  ];

  return (
    <div className="service-section">
      <div className="glowing-spot"></div> {/* Glowing spot animation */}
      <div className="decorated-heading-pcw">
        <GiCalculator className="react-icon-pcw" />
      </div>
      <h1 className="main-heading-pcw">Why Choose Us</h1>
      <p className="description-pcw">
        CA & Associates was founded in 2000 on the core belief that every
        individual and business deserves expert financial guidance.
      </p>
      <div className="service-grid">
        {reasons.map((reason, index) => (
          <div key={index} className="service-item">
            <div className="service-icon">{reason.icon}</div>
            <div className="div-t">
              <h3>{reason.heading}</h3>
              <p>{reason.text}</p>
            </div>
          </div>
        ))}
        <div className="service-center-image">
          <img src="/Nyay.webp" alt="Legal Team" />
        </div>
      </div>
    </div>
  );
};

export default Why;
